import { addDays, isAfter, isBefore } from 'date-fns'

const STARTING_SOON_THRESHOLD_DAYS = 3

export const isStartingSoon = (startTime: Date, numDays = STARTING_SOON_THRESHOLD_DAYS): boolean => {
  const now = new Date()
  return isAfter(startTime, now) && isBefore(startTime, addDays(now, numDays))
}
